<template>
  <div id="fluid-engine" class="fluid-engine" data-sidebar="1">
    <!-- 蓝河流畅引擎 -->
    <div class="fluid-engine-home" ref="fluidEngine" data-position="0" data-name="蓝河流畅引擎">
      <video v-if="isPC" ref="fluidEngineVideo" class="fluid-engine-home-background" :src="fluidEngineWallpaper" preload="metadata" muted></video>
      <PlusImage v-else class="fluid-engine-home-background" :src="fluidEngineWallpaper" />
      <div class="fluid-engine-home-container" v-if="!isPC">
        <p class="fluid-engine-home-title ffm600">丝滑由底而生</p>
        <p class="fluid-engine-home-sub-title ffm600">蓝河流畅引擎</p>
      </div>
      <div :class="['fluid-engine-home-text-container', 'ffm500', { 'show': showHomeText }]">
        <p>基于vivo自研蓝河操作系统的技术沉淀，</p>
        <p>通过超核计算、双渲染架构和光子存储等创新技术，</p>
        <p>让你的操作快人一步、丝滑到底。</p>
      </div>
    </div>
    <div class="fluid-engine-container" data-position="1" data-name="技术解析">
      <!-- 双渲染架构 -->
      <div 
        class="fluid-engine-horizontal-wrapper"
        v-if="isPC"
        ref="horizontalWrapper"
      >

        <div 
          class="fluid-engine-horizontal-container swiper"
        >
          <div class="swiper-wrapper">
            <div 
              v-for="(item, index) in swiperData" 
              :key="index"
              class="fluid-engine-panel swiper-slide"
            >
            <div class="fluid-engine-text-container">
              <p class="fluid-engine-title ffm500">{{ item.title }}</p>
              <div class="fluid-engine-sub-title ffm600">
                <p v-for="(line, index) in item.subTitle" :key="index">{{ line }}</p>
              </div>
              <div class="fluid-engine-description-container ffm400">
                <p v-for="(line, index) in item.descriptionPC" :key="index">{{ line }}</p>
              </div>
            </div>
            <div class="fluid-engine-swiper-container">
              <video :ref="`swiperVideo${index}`" :class="['fluid-engine-swiper-video', ]" :src="item.video" loop muted="true" autoplay playsinline webkit-playsinline preload="metadata"></video>
            </div>
            <div :class="['fluid-engine-swiper-data',]">
              <div 
                v-for="(dataItem, dataIndex) in item.data" 
                :key="dataIndex"
                class="fluid-engine-swiper-data-item"
              >
                <p class="fluid-engine-swiper-data-item-unit ffm500">{{ dataItem.unit }}</p>
                <p class="fluid-engine-swiper-data-item-number ffm600">{{ dataItem.number }}</p>
              </div>
            </div>
            </div>
          </div>
        </div>
        <div class="fluid-engine-swiper-controllor">
          <ul>
            <li
              v-for="(item, index) in swiperData"
              :key="index"
              :class="{ active: currentIndex === index }"
            ></li>
          </ul>
        </div>
      </div>
      <div v-else class="fluid-engine-slide-container">

        <div v-for="(item, index) in swiperData" :key="index" class="fluid-engine-slide" v-animate>
          <div class="fluid-engine-text-container">
              <p class="fluid-engine-title ffm500">{{ item.title }}</p>
              <p v-if="isMobile" class="fluid-engine-sub-title ffm600">{{ item.subTitle.join('') }}</p>
              <div v-else class="fluid-engine-sub-title ffm600" >
                <p v-for="(line, index) in item.subTitle" :key="index">{{ line }}</p>
              </div>
              <div class="fluid-engine-description-container ffm400" :class="{'maxwidth187': isPad && index === 2}">
                <template v-if="isMobile">
                  <p v-for="(line, index) in item.descriptionH5" :key="index">{{ line }}</p>
                </template>
                <template v-else-if="isPad">
                  <p v-for="(line, index) in item.descriptionPad" :key="index">{{ line }}</p>
                </template>
              </div>
              <div :class="['fluid-engine-swiper-data']">
              <div 
                v-for="(dataItem, dataIndex) in item.data" 
                :key="dataIndex"
                class="fluid-engine-swiper-data-item"
              >
                <p class="fluid-engine-swiper-data-item-unit ffm500">{{ dataItem.unit }}</p>
                <p class="fluid-engine-swiper-data-item-number ffm600">{{ dataItem.number }}</p>
              </div>
            </div>
          </div>
          <div :class="['fluid-engine-video-container', `nth-${index}`]">
            <PlusImage :class="['fluid-engine-swiper-video', ]" :src="item.contextBG" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 看起来就流畅 -->
    <div class="fluid-engine-gradient-text-container">

      <ScrollTextGradient
        v-if="isPC"
        class="fluid-engine-gradient-text"
        :texts="['看起来就流畅']"
        :backgroundColor="'rgba(255, 255, 255, 0.1)'"
        :themeColor="'#2785FF'"
        :endColor="'#DBEFFF'"
        :fontSize="gradientTextConfig.fontSize"
        :fontWeight="gradientTextConfig.fontWeight"
        :lineHeight="gradientTextConfig.lineHeight"
        :startTrigger="`top+=${gradientTextHeight} bottom`"
        :endTrigger="'top 10%'"
        :activateRatio="0"
        :activateDelay="200"
      />
      <div v-else class="fluid-engine-gradient-text ffm600" v-animate>看起来就流畅</div>
    </div>
    <div class="fluid-engine-technology-container">
      <!-- 弹性动效 -->
      <div class="fluid-engine-bouncy-animation" data-position="2" data-name="弹性动效">
        <div class="fluid-engine-bouncy-animation-text-container" v-animate>
          <p class="fluid-engine-bouncy-animation-title ffm500">弹性动效</p>
          <p class="fluid-engine-bouncy-animation-sub-title ffm600">更Q弹，更丝滑</p>
          <p class="fluid-engine-bouncy-animation-description ffm400">点一点、滑一滑，每个操作你都能感受到Spring力学反馈带来的细腻质感。</p>
        </div>
        <div class="fluid-engine-bouncy-animation-video-container" v-animate>
          <div class="fluid-engine-bouncy-animation-video-left">
            <div class="bouncy-animation-phone-container">
              <PlusImage class="bouncy-animation-phone-model" :src="FLUID_ENGINE.phoneModel"></PlusImage>
              <video v-if="isPC" ref="bouncyAnimationAppVideo" class="bouncy-animation-phone-wallpaper" :src="VIDEO.bouncyAnimationApp" preload="metadata" playsinline webkit-playsinline muted loop></video>
              <PlusImage v-else class="bouncy-animation-phone-wallpaper" :src="FLUID_ENGINE.phoneWallpaper7"></PlusImage>
            </div>
            <p class="bouncy-animation-phone-description ffm400">后台近期应用</p>
          </div>
          <div class="fluid-engine-bouncy-animation-video-right">
            <div class="bouncy-animation-phone-container">
              <PlusImage class="bouncy-animation-phone-model" :src="FLUID_ENGINE.phoneModel"></PlusImage>
              <video v-if="isPC" ref="bouncyAnimationFocusVideo" class="bouncy-animation-phone-wallpaper" :src="VIDEO.bouncyAnimationFocus" preload="metadata" playsinline webkit-playsinline muted loop></video>
              <PlusImage v-else class="bouncy-animation-phone-wallpaper" :src="FLUID_ENGINE.phoneWallpaper8"></PlusImage>
              <PlusImage v-if="!isPC" class="bouncy-animation-phone-finger" :src="FLUID_ENGINE.fingerPointer1"></PlusImage>
            </div>
            <p class="bouncy-animation-phone-description ffm400">桌面图标拖动</p>
          </div>
        </div>
      </div>
      <!-- 三大技术 -->
      <div class="fluid-engine-card-container">
        <!-- 帧形变 -->
        <div :class="['fluid-engine-frame-deformation', 'card']" v-animate data-position="3" data-name="帧形变">
          <div class="fluid-engine-frame-deformation-content">
            <p class="fluid-engine-text-title ffm500">帧形变</p>
            <p class="fluid-engine-text-sub-title ffm600">界面会拉伸、会融合</p>
            <div class="fluid-engine-text-description ffm400">
              <p>当你滑动、点击、切换时，界面元素会像水滴般彼此粘连、融合、滴落，为你呈现舒适又富有表现力的形变动画。</p>
            </div>
          </div>
          <div class="fluid-engine-phone-container">
            <PlusImage class="fluid-engine-phone-model" :src="FLUID_ENGINE.phoneModel2"></PlusImage>
            <video v-if="isPC" ref="frameDeformationVideo" class="fluid-engine-phone-wallpaper" :src="VIDEO.frameDeformationVideo" preload="metadata" muted playsinline webkit-playsinline loop></video>
            <PlusImage v-else class="fluid-engine-phone-wallpaper" :src="FLUID_ENGINE.phoneWallpaper9"></PlusImage>
            <PlusImage v-if="!isPC" class="fluid-engine-phone-finger" :src="FLUID_ENGINE.fingerPointer2"></PlusImage>
          </div>
        </div>
        <!-- 帧模糊 -->
        <div :class="['fluid-engine-frame-blur', 'card']" v-animate data-position="4" data-name="帧模糊">
          <div class="fluid-engine-frame-blur-content">
            <p class="fluid-engine-text-title ffm500">帧模糊</p>
            <p class="fluid-engine-text-sub-title ffm600">界面切换更顺眼</p>
            <div class="fluid-engine-text-description ffm400 wd424">
              <p>像相机的对焦过程，画面切换时，新画面渐显，背景虚化，让过渡更舒适、重点更突出。</p>
            </div>
          </div>
          <div class="fluid-engine-phone-container">
            <PlusImage class="fluid-engine-phone-model" :src="FLUID_ENGINE.phoneModel2"></PlusImage>
            <video v-if="isPC" ref="frameBlurVideo" class="fluid-engine-phone-wallpaper" :src="VIDEO.frameBlurVideo" preload="metadata" muted playsinline webkit-playsinline loop></video>
            <PlusImage v-else class="fluid-engine-phone-wallpaper" :src="FLUID_ENGINE.phoneWallpaper10"></PlusImage>
          </div>
        </div>
        <!-- 一镜到底 -->
        <div :class="['fluid-engine-one-shot', 'card']" v-animate data-position="5" data-name="一镜到底">
          <div class="fluid-engine-one-shot-content">
            <p class="fluid-engine-text-title ffm500">一镜到底</p>
            <p class="fluid-engine-text-sub-title ffm600">流畅过渡，全情专注</p>
            <div class="fluid-engine-text-description ffm400 wd424">
              <p>小窗横竖屏旋转、桌面添加组件、负一屏打开应用、相册进入预览图等场景引入“一镜到底”动效，整个过程画面连贯、无跳变，就像电影的一镜到底，让你始终保持专注。</p>
            </div>
          </div>
          <div class="fluid-engine-phone-container">
            <PlusImage v-if="!isPC" class="fluid-engine-phone-model" :src="FLUID_ENGINE.phoneModel3"></PlusImage>
            <video v-if="isPC" ref="oneShotVideo" class="fluid-engine-phone-wallpaper" :src="VIDEO.oneShot" muted="true" preload="metadata" playsinline webkit-playsinline></video>
            <PlusImage v-else class="fluid-engine-phone-wallpaper" :src="FLUID_ENGINE.phoneWallpaper11"></PlusImage>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { FLUID_ENGINE } from "@/config/image";
import VIDEO from "@/config/video";
import { initExposureTrack } from "@/utils/track.js";
import ScrollTextGradient from "@/components/ScrollTextGradient.vue";
import { gsap, ScrollTrigger } from "@/utils/gsapConfig.js";
import PlusImage from "@/components/PlusImage.vue";
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

export default {
  name: "FluidEngine",
  components: {
    ScrollTextGradient,
    PlusImage
  },
  data() {
    return {
      FLUID_ENGINE,
      VIDEO,
      currentIndex: 0,
      swiperData: [],
      scrollTriggerInstance: null,
      resizeHandler: null,
      resizeTimeout: null,
      swiperVideoObservers: [],
      allVideoObservers: [],
      showHomeText: false,
      videoRefs: [
        'bouncyAnimationAppVideo',
        'bouncyAnimationFocusVideo',
        'frameDeformationVideo',
        'frameBlurVideo',
      ],
    };
  },
  created() {
    this.swiperData = [
        {
          title: "虚拟显卡-双渲染架构",
          subTitle: ["双路渲染，", "丝滑流畅"],
          descriptionPC: [
            "两套渲染架构：",
            "一套负责中低负载的常规渲染场景，",
            "一套专门应对动效这类高爆发性渲染需求。"
          ],
          descriptionH5: [
            "两套渲染架构：一套负责中低负载的常规渲染场景，",
            "一套专门应对动效这类高爆发性渲染需求。"
          ],
          descriptionPad: [
            "两套渲染架构：",
            "一套负责中低负载的常规渲染场景，",
            "一套专门应对动效这类高爆发性渲染需求。"
          ],
          video: VIDEO.fluidEngineDualRenderingArchitecture,
          contextBG: FLUID_ENGINE.dualRenderingArchitectureBG,
          data: [
            { unit: "帧率稳定性提升", number: "11%↑" },
            { unit: "渲染效率提升", number: "35%↑" },
          ],
        },
        {
          title: "异构计算空间-超核计算",
          subTitle: ["响应更快，", "当然更尽兴"],
          descriptionPC: ["应用启动、页面切换、内容加载都更快，","超核计算帮你把算力安排得明明白白。"],
          descriptionH5: ["应用启动、页面切换、内容加载都更快，","超核计算帮你把算力安排得明明白白。"],
          descriptionPad: ["应用启动、页面切换、内容加载都更快，超核计算帮你把算力安排得明明白白。"],
          video: VIDEO.fluidEngineHyperCoreComputing,
          contextBG: FLUID_ENGINE.hyperCoreComputingBG,
          data: [
            { unit: "应用启动速度提升", number: "11%↑" },
            { unit: "30个应用连续启动速度提升", number: "14%↑" },
          ],
        },
        {
          title: "存储融合-光子存储",
          subTitle: ["高负载，", "照样快到飞起"],
          descriptionPC: ["在你长时间刷视频、开很多应用时，", "能够高效地利用手机CPU缓存、内存和存储，","让加载更快、切换更顺。"],
          descriptionH5: [
            "在你长时间刷视频、开很多应用时，能够高效地利用手",
            "机CPU缓存、内存和存储，让加载更快、切换更顺。"
          ],
          descriptionPad: ['在你长时间刷视频、开很多应用时，能够高效地利用手机CPU缓存、内存和存储，让加载更快、切换更顺。'],
          video: VIDEO.fluidEnginePhotonicStorage,
          contextBG: FLUID_ENGINE.photonicStorageBG,
          data: [
            { unit: "重载场景数据加载速度提升", number: "230%↑" },
            { unit: "内存回收速度提升", number: "15%↑" },
          ],
        }
      ];
  },
  props: {},
  methods: {
    initSwiperAndScroll() {
      if (!this.isPC) return;
      const horizontalWrapper = this.$refs.horizontalWrapper;
      if (!horizontalWrapper) return;

      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      if (this._scrollSwiperTrigger) {
        this._scrollSwiperTrigger.kill();
        this._scrollSwiperTrigger = null;
      }

      this.swiper = new Swiper('.fluid-engine-horizontal-container', {
        slidesPerView: 1,
        allowTouchMove: false,
        speed: 800,
        resistanceRatio: 0,
        on: {
          slideChange: () => {
            this.currentIndex = this.swiper.activeIndex;
          }
        }
      });

      const totalSlides = this.swiper.slides.length - 1;
      const snap = gsap.utils.snap(1 / totalSlides);

      const scrollDistance = window.innerHeight * totalSlides * 1.5;

      this._scrollSwiperTrigger = ScrollTrigger.create({
        // markers: true,
        trigger: horizontalWrapper,
        // start: () => 'top -' + (50 / 1920 * window.innerWidth),
        // start: () => 'bottom bottom',
        start: 'center center',
        end: '+=' + scrollDistance,
        pin: true,
        anticipatePin: 1,
        onUpdate: (self) => {
          const snapped = snap(self.progress);
          let targetIndex = Math.round(snapped * totalSlides);
          if (targetIndex < 0) targetIndex = 0;
          if (targetIndex > totalSlides) targetIndex = totalSlides;
          if (targetIndex !== this.currentIndex) {
            this.swiper.slideTo(targetIndex);
          }
        }
      });
      
      this.initSwiperVideoObservers();
    },
    initScrollTrigger() {
      const container = this.$refs.fluidEngine
      const video = this.$refs.fluidEngineVideo;
      if (!container || !video) return

      if (this.scrollTriggerInstance) {
        this.scrollTriggerInstance.kill()
      }

      this.videoHasLeftView = false;
      let playPromise;

      this.scrollTriggerInstance = ScrollTrigger.create({
        // markers: true,
        trigger: container,
        start: () => {
          const offset = 43 / 1920 * window.innerWidth;
          return `center center+=${offset}`;
        },
        end: '+=' + container.offsetHeight,
        pin: '.fluid-engine-home',
        anticipatePin: 1,
        onEnter: () => {
          if (!this.videoHasLeftView  && !this.isPageReloadPlayCheck) return;
          if (!video.ended) {
            playPromise = video.play();
          }
          this.checkVideoProgress();
          this.videoHasLeftView = false;
        },
      })

      this.$nextTick(() => {
        const rect = container.getBoundingClientRect();
        const inViewport =
          rect.top < window.innerHeight && rect.bottom > 0;
        const isAnchorJump = window.location.hash === '#fluid-engine';
        
        if (inViewport || isAnchorJump) {
          this.isPageReloadPlayCheck = true;
          if (!video.ended) {
            playPromise = video.play().catch(err => console.log('视频播放失败:', err));
          }
          this.checkVideoProgress();
          this.videoHasLeftView = false;
        } else if (rect.top <= 0 && rect.bottom <= 0) {
          // 视频区域完全在视口上方
          this.videoHasLeftView = false;
          this.showHomeText = true;
          
          const setVideoToEnd = () => {
            if (video.duration && isFinite(video.duration) && video.duration > 0) {
              video.currentTime = video.duration;
            }
          };
          
          if (video.readyState >= 1) {
            setVideoToEnd();
          } else {
            video.addEventListener('loadedmetadata', setVideoToEnd, { once: true });
          }
        } else if (rect.top >= window.innerHeight) {
          // 视频在视口下方
        }
      });
    },
    checkVideoProgress() {
      const video = this.$refs.fluidEngineVideo;
      if (!video) return;

      const handler = (event) => {
        const currentTime = event.target.currentTime; // 直接从事件获取，避免DOM查询
        if (currentTime >= 2.6 && !this.showHomeText) {
          this.showHomeText = true;
          video.removeEventListener('timeupdate', handler);
        }
      };
      
      // 使用passive监听器提升滚动性能
      video.addEventListener('timeupdate', handler, { passive: true });
    },

    initEventListener() {
      const that = this;
      const container = this.$refs.fluidEngine;
      const video = this.$refs.fluidEngineVideo;
      if (!container || !video) return;

      let ticking = false; // 节流flag
      let lastState = false; // 缓存上次状态
      
      $(window).on("scroll.videoReset", function () {
        if (!ticking) {
          requestAnimationFrame(() => {
            const rect = container.getBoundingClientRect();
            const distanceFromTopToViewportBottom = window.innerHeight - rect.top;
            const shouldReset = distanceFromTopToViewportBottom < 10;
            
            if (shouldReset !== lastState) {
              lastState = shouldReset;
              if (shouldReset) {
                that.videoHasLeftView = true;
                video.currentTime = 0;
                that.showHomeText = false;
              }
            }
            ticking = false;
          });
          ticking = true;
        }
      });
    },

    createVideoObserver(video, threshold = 1.0) {
      let playPromise;
      let lastPlayState = null; // 缓存上次播放状态，避免重复操作
      
      return new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (!entry) return;
        
        const shouldPlay = entry.isIntersecting && entry.intersectionRatio >= threshold && !video.ended;
        
        // 状态未改变时直接返回，避免重复的DOM操作
        if (shouldPlay === lastPlayState) return;
        lastPlayState = shouldPlay;
        
        if (shouldPlay) {
          playPromise = video.play();
        } else {
          if (!video.ended && playPromise !== undefined) {
            playPromise.finally(() => {
              if (lastPlayState === false) {
                video.pause();
              }
            });
          }
        }
      }, {
        threshold: threshold
      });
    },

    createOneShotVideoObserver(video) {
      let hasFullyLeft = false;
      let hasFullyEnteredOnce = false;
      let playPromise;
      let lastState = { playing: null, ratio: -1 }; // 缓存状态避免重复计算
      
      return new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (!entry) return;
        
        const ratio = entry.intersectionRatio;
        const isIntersecting = entry.isIntersecting;
        
        // 相同状态下跳过处理
        if (ratio === lastState.ratio && isIntersecting === lastState.intersecting) {
          return;
        }
        lastState.ratio = ratio;
        lastState.intersecting = isIntersecting;
        
        if (isIntersecting) {
          if (ratio >= 1.0) {
            hasFullyEnteredOnce = true;
            
            if (hasFullyLeft) {
              video.currentTime = 0;
              hasFullyLeft = false;
            }
            
            if (lastState.playing !== true) {
              playPromise = video.play();
              lastState.playing = true;
            }
          }
          else if (ratio < 0.4 && hasFullyEnteredOnce && lastState.playing === true) {
            if (playPromise !== undefined) {
              playPromise.finally(() => {
                if (lastState.playing === true && entry.intersectionRatio < 0.4) {
                  // video.pause();
                  lastState.playing = false;
                }
              });
            }
          }
        } else {
          if (ratio === 0) {
            hasFullyLeft = true;
          }
          if (lastState.playing === true && playPromise !== undefined) {
            playPromise.finally(() => {
              if (!entry.isIntersecting) {
                video.pause();
                lastState.playing = false;
              }
            });
          }
        }
      }, {
        threshold: [0, 0.4, 1.0] // 监听完全离开(0)、60%超出(0.4)和完全可见(1.0)
      });
    },

    initVideoObserver() {
      this.initAllVideoObservers();
    },

    initSwiperVideoObservers() {
      if (!this.isPC) return;
      
      this.$nextTick(() => {
        this.clearSwiperVideoObservers();
        
        this.swiperData.forEach((item, index) => {
          const video = this.$refs[`swiperVideo${index}`];
          if (video && video[0]) {
            const observer = this.createVideoObserver(video[0], 1.0);
            observer.observe(video[0]);
            this.swiperVideoObservers.push(observer);
          }
        });
      });
    },

    clearSwiperVideoObservers() {
      this.swiperVideoObservers.forEach(observer => {
        observer.disconnect();
      });
      this.swiperVideoObservers = [];
    },

    initAllVideoObservers() {
      if (!this.isPC) return;
      
      this.$nextTick(() => {
        // this.clearAllVideoObservers();
        
        const oneShotVideo = this.$refs.oneShotVideo;
        if (oneShotVideo) {
          const observer = this.createOneShotVideoObserver(oneShotVideo);
          observer.observe(oneShotVideo);
          this.allVideoObservers.push(observer);
        }

        this.videoRefs.forEach(refName => {
          const video = this.$refs[refName];
          if (video) {
            const threshold = refName === 'frameBlurVideo' ? 0.45 : 1.0;
            const observer = this.createVideoObserver(video, threshold);
            observer.observe(video);
            this.allVideoObservers.push(observer);
          }
        });
      });
    },

    clearAllVideoObservers() {
      this.allVideoObservers.forEach(observer => {
        observer.disconnect();
      });
      this.allVideoObservers = [];
    },

    handleAnchorJump() {
      setTimeout(() => {
        const container = this.$refs.fluidEngine;
        const video = this.$refs.fluidEngineVideo;
        if (!container || !video) return;

        const rect = container.getBoundingClientRect();
        const inViewport = rect.top < window.innerHeight && rect.bottom > 0;
        
        if (inViewport) {
          this.isPageReloadPlayCheck = true;
          if (!video.ended) {
            video.play().catch(err => console.log('视频播放失败:', err));
          }
          this.checkVideoProgress();
          this.videoHasLeftView = false;
        }
      }, 200);
    },
  },
  computed: {
    ...mapGetters(['isMobile', 'isPad', 'isPC']),
    gradientTextHeight() {
      return 77 / 1920 * window.innerWidth
    },
    fluidEngineWallpaper() {
      if (this.isPC) {
        return this.VIDEO.fluidEngineBackground
      } else if (this.isPad) {
        return this.FLUID_ENGINE.wallpaperPad
      } else {
        return this.FLUID_ENGINE.wallpaperPhone
      }
    },
    gradientTextConfig() {
      if (this.isPC) {
        return {
          fontSize: 80,
          fontWeight: 600,
          lineHeight: 76.8
        }
      } else {
        return {
          fontSize: 42,
          fontWeight: 600,
          lineHeight: 'normal'
        }
      }
    }
  },
  mounted() {
    initExposureTrack('.fluid-engine [data-position]')()
    if (this.isPC) {
      this.initScrollTrigger();
      this.initSwiperAndScroll();
      this.initVideoObserver();
      this.initEventListener();
      ScrollTrigger.refresh();
    }
    let lastWidth = window.innerWidth;
    this.resizeHandler = () => {
      if (this.isPC) {
        if (Math.abs(window.innerWidth - lastWidth) > 10) {
          lastWidth = window.innerWidth;
          this.initScrollTrigger();
          this.initSwiperAndScroll();
          this.initVideoObserver();
          this.initEventListener();
          ScrollTrigger.refresh();
        }
      }
    };
    window.addEventListener('resize', this.resizeHandler)
  },
};
</script>

<style lang="scss" scoped>
.fluid-engine {
  position: relative;
  background: #000000;
}
.fluid-engine{
  :deep(.pin-spacer) {
    background: #000000;
  }

  // 蓝河流畅引擎
  .fluid-engine-home{
    height: calc(920) * $px1920vw + vw;
    width: 100vw;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    .fluid-engine-home-background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      z-index: 0;
    }

    .fluid-engine-home-container{
      // top: 261 * $px1920vw + vw;
      position: absolute;
      display: flex;
      justify-content: center;
      flex-direction: column;
      z-index: 1;

      .fluid-engine-home-title{
        letter-spacing: normal;
        background: linear-gradient(90deg, #DBEFFF 0%, #2785FF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        color: transparent;
      }

      .fluid-engine-home-sub-title{
        letter-spacing: normal;
        background: linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(180deg, #FFFFFF 33%, rgba(255, 255, 255, 0) 129%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        color: transparent;
      }

    }

    .fluid-engine-home-text-container{
      font-size: 18 * $px1920vw + vw;
      line-height: 28 * $px1920vw + vw;
      text-align: center;
      letter-spacing: normal;
      color: #FFFFFF;
      top: 696 * $px1920vw + vw;
      position: absolute;
      z-index: 1;
      opacity: 0;
      p {
        white-space: nowrap;
      }
      &.show {
        opacity: 1;
        transition: opacity 0.5s ease-in-out;
      }
    }
  }
  
  // 双渲染架构 - 水平滚动
  .fluid-engine-horizontal-wrapper{
    height: 920 * $px1920vw + vw;
    width: 100vw;
    position: relative;
    overflow: hidden;
    background: radial-gradient(49% 20% at 50% 79%, #0B2A4D 0%, #000000 100%);

    .swiper-wrapper{
      transition-timing-function: cubic-bezier(0.42, 0.0, 0.58, 1.0);
    }
      
    .fluid-engine-horizontal-background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      z-index: 0;
    }

    .fluid-engine-horizontal-container {
      height: 100%;
      display: flex;
      position: relative;
      z-index: 1;
      
      .fluid-engine-panel {
        width: 100vw;
        height: 100%;
        position: relative;
        flex-shrink: 0;
        
        &:nth-child(2),&:nth-child(3){
          .fluid-engine-text-container{
            top: 150 * $px1920vw + vw;
          }
          .fluid-engine-swiper-data{
            flex-direction: column;
            bottom: 154 * $px1920vw + vw;
            gap: 40 * $px1920vw + vw;
            align-items: start;
          }
        }
      }
    }

    .fluid-engine-text-container{
      top: 215 * $px1920vw + vw;
      left: 290 * $px1920vw + vw;
      position: absolute;
      text-align: start;
      z-index: 1;

      .fluid-engine-title{
        font-size: 28 * $px1920vw + vw;
        line-height: 33.6 * $px1920vw + vw;
        letter-spacing: normal;
        color: #2785FF;
        top: 0;
        position: relative;
      }
    
      .fluid-engine-sub-title{
        font-size: 64 * $px1920vw + vw;
        line-height: 76.8 * $px1920vw + vw;
        letter-spacing: normal;
        color: #FFFFFF;
        margin-top: 12 * $px1920vw + vw;
      }

      .fluid-engine-description-container{
        font-size: 18 * $px1920vw + vw;
        line-height: 25.2 * $px1920vw + vw;
        letter-spacing: normal;
        color: rgba(255, 255, 255, 1);
        margin-top: 24 * $px1920vw + vw;
      }
    }

    .fluid-engine-swiper-container{
      top: 150 * $px1920vw + vw;
      left: 790 * $px1920vw + vw;
      width: 840 * $px1920vw + vw;
      height: 620 * $px1920vw + vw;
      border-radius: 24 * $px1920vw + vw;
      border: 1px solid rgba(59, 48, 82, 1);
      overflow: hidden;
      position: absolute;
      z-index: 1;

      .fluid-engine-swiper-video{
        width: 100%;
        height: 100%;
        border-radius: 24 * $px1920vw + vw;
        overflow: hidden;
      }
    }
    .fluid-engine-swiper-data{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      bottom: 188 * $px1920vw + vw;
      left: 290 * $px1920vw + vw;
      position: absolute;
      gap: 48 * $px1920vw + vw;
      z-index: 1;

      .fluid-engine-swiper-data-item{
        letter-spacing: normal;
        color: #FFFFFF;
        text-align: start;
        .fluid-engine-swiper-data-item-unit{
          font-size: 24 * $px1920vw + vw;
          line-height: 28.8 * $px1920vw + vw;
        }
        .fluid-engine-swiper-data-item-number{
          font-size: 48 * $px1920vw + vw;
          line-height: 57.6 * $px1920vw + vw;
        }
      }
    }

    .fluid-engine-swiper-controllor{
      position: absolute;
      bottom: 28 * $px1920vw + vw;
      left: 50%;
      transform: translateX(-50%);
      width: 140 * $px1920vw + vw;
      height: 42 * $px1920vw + vw;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 42 * $px1920vw + vw;
      padding: 17.5 * $px1920vw + vw 21 * $px1920vw + vw;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 5;
      
      ul {
        font-size: 0;
        margin: 0;
        padding: 0;
        display: flex;
        align-items: center;
        gap: 14 * $px1920vw + vw;
        
        li {
          width: 7 * $px1920vw + vw;
          height: 7 * $px1920vw + vw;
          border-radius: 7 * $px1920vw + vw;
          background: rgba(255, 255, 255, 0.5);
          transition: all ease-in-out 0.5s;
          
          &:last-child {
            margin-right: 0;
          }
          
          &.active {
            width: 54 * $px1920vw + vw;
          }
        }
      }
    }

  }

  // 看起来就流畅
  .fluid-engine-gradient-text-container{
    height: 473 * $px1920vw + vw;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    .fluid-engine-gradient-background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      z-index: 0;
    }

    .fluid-engine-gradient-text{
      top: 213 * $px1920vw + vw;
      position: absolute;
      z-index: 1;
    }
  }

  .fluid-engine-technology-container{
    background: rgb(30, 30, 30, 1);
  }

  // 弹性动效
  .fluid-engine-bouncy-animation{
    height: 877 * $px1920vw + vw;
    background: linear-gradient(180deg, #000000 54%, #1E1E1E 100%);
    position: relative;

    .fluid-engine-bouncy-animation-text-container{
      display: flex;
      flex-direction: column;
      align-items: center;

      .fluid-engine-bouncy-animation-title{
        font-size: 28 * $px1920vw + vw;
        line-height: 33.6 * $px1920vw + vw;
        text-align: center;
        letter-spacing: normal;
        color: #2785FF;
      }

      .fluid-engine-bouncy-animation-sub-title{
        font-size: 64 * $px1920vw + vw;
        line-height: 76.8 * $px1920vw + vw;
        text-align: center;
        letter-spacing: normal;
        color: #FFFFFF;
        margin-top: 12 * $px1920vw + vw;
      }

      .fluid-engine-bouncy-animation-description{
        font-size: 18 * $px1920vw + vw;
        line-height: 25.2 * $px1920vw + vw;
        text-align: center;
        letter-spacing: normal;
        color: rgba(255, 255, 255, 0.8);
        margin-top: 24 * $px1920vw + vw;
      }
    }

    .fluid-engine-bouncy-animation-video-container{
      margin-top: 50 * $px1920vw + vw;
      display: flex;

      justify-content: center;

      .fluid-engine-bouncy-animation-video-left{
        margin-right: 59 * $px1920vw + vw;
      }

      .fluid-engine-bouncy-animation-video-left,
      .fluid-engine-bouncy-animation-video-right{
        display: flex;
        align-items: center;
        position: relative;
        flex-direction: column;
      }

      .bouncy-animation-phone-container{
        height: 561.64 * $px1920vw + vw;
      }

      .bouncy-animation-phone-model{
        width: 270 * $px1920vw + vw;
        height: 561.64 * $px1920vw + vw;
        z-index: 10;
        position: relative;
        bottom: 0;
        left: 0;
      }

      .bouncy-animation-phone-wallpaper{
        width: 250.82 * $px1920vw + vw;
        height: auto;
        position: absolute;
        top: 8.65 * $px1920vw + vw;
        left: 8.66 * $px1920vw + vw;
        border-radius: 24.75 * $px1920vw + vw;
        z-index: 9;
        overflow: hidden;
      }

    }

    .bouncy-animation-phone-description{
      font-size: 18 * $px1920vw + vw;
      line-height: 25.2 * $px1920vw + vw;
      letter-spacing: normal;
      color: rgba(255, 255, 255, 0.6);
      margin-top: 18.36 * $px1920vw + vw;
    }

  }

  // 三大科技
  .fluid-engine-card-container{
    height: 2086 * $px1920vw + vw;
    background: rgb(30, 30, 30, 1);
    padding: 120 * $px1920vw + vw 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 24 * $px1920vw + vw;

    .card{
      height: 599 * $px1920vw + vw;
      width: 1199 * $px1920vw + vw;
      border-radius: 24 * $px1920vw + vw;
      background: rgba(0, 0, 0, 1);
      overflow: hidden;
      position: relative;
      letter-spacing: normal;
      text-align: start;

      .fluid-engine-text-title{
          font-size: 28 * $px1920vw + vw;
          line-height: 33.6 * $px1920vw + vw;
          color: #2785FF;
        }

        .fluid-engine-text-sub-title{
          font-size: 40 * $px1920vw + vw;
          line-height: 48 * $px1920vw + vw;
          color: #FFFFFF;
          margin-top: 12 * $px1920vw + vw;
        }

        .fluid-engine-text-description{
          font-size: 18 * $px1920vw + vw;
          line-height: 25.2 * $px1920vw + vw;
          color: rgba(255, 255, 255, 0.8);
          margin-top: 36 * $px1920vw + vw;
          max-width: 396 * $px1920vw + vw;
          &.wd424 {
            max-width: 424 * $px1920vw + vw;
          }
        }
    }

    .fluid-engine-phone-wallpaper{
      overflow: hidden;
    }
       
    // 帧形变
    .fluid-engine-frame-deformation{
      .fluid-engine-frame-deformation-content{
        position: absolute;
        top: 197 * $px1920vw + vw;
        left: 78 * $px1920vw + vw;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

      }
      .fluid-engine-phone-container{
        width: 244 * $px1920vw + vw;
        height: 508 * $px1920vw + vw;
        bottom: 45 * $px1920vw + vw;
        right: 228 * $px1920vw + vw;
        position: absolute;
        
        .fluid-engine-phone-model{
          width: 100%;
          height: 100%;
          z-index: 10;
          position: absolute;
          bottom: 0;
          left: 0;
        }

        .fluid-engine-phone-wallpaper{
          width: 226.86 * $px1920vw + vw;
          height: 492.53 * $px1920vw + vw;
          position: absolute;
          bottom: 7.64 * $px1920vw + vw;
          left: 7.84 * $px1920vw + vw;
          border-radius: 22.39 * $px1920vw + vw;
          z-index: 9;
          overflow: hidden;
        }
      }
    }
  
    // 帧模糊
    .fluid-engine-frame-blur{
      .fluid-engine-frame-blur-content{
        position: absolute;
        top: 209 * $px1920vw + vw;
        right: 65 * $px1920vw + vw;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .fluid-engine-text-sub-title{
          white-space: nowrap;
        }
      }
      .fluid-engine-phone-container{
        width: 450 * $px1920vw + vw;
        height: 936.07 * $px1920vw + vw;
        bottom: 143.33 * $px1920vw + vw;
        left: 143 * $px1920vw + vw;
        position: absolute;
        
        .fluid-engine-phone-model{
          width: 100%;
          height: 100%;
          z-index: 10;
          position: absolute;
          bottom: 0;
          left: 0;
        }

        .fluid-engine-phone-wallpaper{
          width: 418.03 * $px1920vw + vw;
          height: 907.56 * $px1920vw + vw;
          position: absolute;
          bottom: 14.08 * $px1920vw + vw;
          left: 14.44 * $px1920vw + vw;
          border-radius: 41.25 * $px1920vw + vw;
          z-index: 9;
        }
      }
    }
  
    // 一镜到底
    .fluid-engine-one-shot{
      .fluid-engine-one-shot-content{
        position: absolute;
        top: 185 * $px1920vw + vw;
        left: 78 * $px1920vw + vw;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
      .fluid-engine-phone-container{
        width: 550 * $px1920vw + vw;
        height: 550 * $px1920vw + vw;
        bottom: 25 * $px1920vw + vw;
        right: 75 * $px1920vw + vw;
        position: absolute;
        
        .fluid-engine-phone-model{
          width: 100%;
          height: auto;
          z-index: 10;
          position: absolute;
          bottom: 0;
          left: 0;
        }

        .fluid-engine-phone-wallpaper{
          width: 100%;
          height: 100%;
          position: absolute;
          z-index: 9;
        }
      }
      .fluid-engine-replay-button-container{
        bottom: 32 * $px1920vw + vw;
        right: 32 * $px1920vw + vw;
        width: 56 * $px1920vw + vw;
        height: 56 * $px1920vw + vw;
        position: absolute;
        border-radius: 24 * $px1920vw + vw;
        cursor: pointer;
        transition: opacity 0.3s ease-in-out;

        &:hover {
          opacity: 0.8
        }
      }
    }
  }
}

// pad端
.isPad {
  .fluid-engine{
    // 蓝河流畅引擎
    .fluid-engine-home{
      height: 400 * $px676vw + vw;

      .fluid-engine-home-container{
        top: 99 * $px676vw + vw;

        .fluid-engine-home-title{
          font-size: 25 * $px676vw + vw;
          line-height: normal;
        }

        .fluid-engine-home-sub-title{
          margin-top: 12 * $px676vw + vw;
          font-size: 48 * $px676vw + vw;
          line-height: normal;
        }

      }

      .fluid-engine-home-text-container{
        top: 285 * $px676vw + vw;
        font-size: 12 * $px676vw + vw;
        line-height: 16 * $px676vw + vw;
        opacity: 1;
      }
    }
    // 双渲染架构
    .fluid-engine-slide-container{
      background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
      position: relative;

      .fluid-engine-slide-background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        z-index: -1;
      }

      .fluid-engine-slide{
        height: 360 * $px676vw + vw;
        position: relative;
        z-index: 1;
        &:nth-child(2),&:nth-child(3){
          .fluid-engine-text-container{
            top: 32 * $px676vw + vw;
            .fluid-engine-swiper-data{
              flex-direction: column;
              margin-top: 26 * $px676vw + vw;
              gap: 12 * $px676vw + vw;
              align-items: start;
            }
          }
        }
        &:nth-child(3){
          .fluid-engine-video-container{
            width: 377 * $px676vw + vw;
            height: 278 * $px676vw + vw;
            top: 41 * $px676vw + vw;
            left: 277 * $px676vw + vw;
          }
        }
        .fluid-engine-text-container{
          top: 52 * $px676vw + vw;
          left: 70 * $px676vw + vw;
          position: absolute;
          text-align: start;
          letter-spacing: normal;

          .fluid-engine-title{
            font-size: 12 * $px676vw + vw;
            line-height: normal;
            color: #2785FF;
          }
          .fluid-engine-sub-title{
            font-size: 25 * $px676vw + vw;
            line-height: normal;
            color: #FFFFFF;
            margin-top: 6 * $px676vw + vw;
          }
          .fluid-engine-description-container{
            font-size: 12 * $px676vw + vw;
            line-height: 16 * $px676vw + vw;
            color: rgba(255, 255, 255, 0.8);
            margin-top: 12 * $px676vw + vw;
            max-width: 238 * $px676vw + vw;
            &.maxwidth187 {
              max-width: 187 * $px676vw + vw;
            }
          }
          .fluid-engine-swiper-data{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            margin-top: 54 * $px676vw + vw;
            gap: 20 * $px676vw + vw;
            white-space: nowrap;

            .fluid-engine-swiper-data-item{
              letter-spacing: normal;
              color: #FFFFFF;
              .fluid-engine-swiper-data-item-unit{
                font-size: 9.6 * $px676vw + vw;
                line-height: 11.52 * $px676vw + vw;
              }
              .fluid-engine-swiper-data-item-number{
                font-size: 20 * $px676vw + vw;
                line-height: 24 * $px676vw + vw;
              }
            }
          }
        }
        .fluid-engine-video-container{
          height: 241 * $px676vw + vw;
          width: 326 * $px676vw + vw;
          top: 60 * $px676vw + vw;
          left: 299 * $px676vw + vw;
          position: absolute;
          .fluid-engine-swiper-video{
            width: 100%;
            height: 100%;
            border-radius: 15.48 * $px676vw + vw;
          }
        }
      }
    }
    // 看起来就流畅
    .fluid-engine-gradient-text-container{
      background: #000000;
      height: 180 * $px676vw + vw;
      .fluid-engine-gradient-text{
        top: 68 * $px676vw + vw;
        position: absolute;
        font-size: 42 * $px676vw + vw;
        line-height: normal;
        letter-spacing: normal;
        background: linear-gradient(90deg, #DBEFFF 0%, #2785FF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
    }
    // 弹性动效
    .fluid-engine-bouncy-animation{
      height: 600 * $px676vw + vw;
      display: flex;
      align-items: center;
      flex-direction: column;

      .fluid-engine-bouncy-animation-text-container{
        padding-top: 36 * $px676vw + vw;
        width: 286 * $px676vw + vw;
        .fluid-engine-bouncy-animation-title{
          font-size: 12 * $px676vw + vw;
          line-height: normal;
        }

        .fluid-engine-bouncy-animation-sub-title{
          font-size: 25 * $px676vw + vw;
          line-height: normal;
          margin-top: 6 * $px676vw + vw;
        }

        .fluid-engine-bouncy-animation-description{
          width: 264 * $px676vw + vw;
          font-size: 12 * $px676vw + vw;
          line-height: 16 * $px676vw + vw;
          margin-top: 12 * $px676vw + vw;
        }
      }

      .fluid-engine-bouncy-animation-video-container{
        margin-top: 51 * $px676vw + vw;

        .fluid-engine-bouncy-animation-video-left,
        .fluid-engine-bouncy-animation-video-right{
          width: 160 * $px676vw + vw;
          white-space: nowrap;
        }

        .fluid-engine-bouncy-animation-video-left{
          margin-right: 40 * $px676vw + vw;
        }

        .bouncy-animation-phone-container{
          height: 332.82 * $px676vw + vw;
        }

        .bouncy-animation-phone-model{
          width: 160 * $px676vw + vw;
          height: 332.82 * $px676vw + vw;
        }

        .bouncy-animation-phone-wallpaper{
          width: 148.63 * $px676vw + vw;
          top: 5.13 * $px676vw + vw;
          left: 5.13 * $px676vw + vw;
          border-radius: 14.67 * $px676vw + vw;
        }
        .bouncy-animation-phone-finger{
          top: calc(184.72 - 12.69) * $px676vw + vw;
          left: calc(65.45 - 11.7) * $px676vw + vw;
          width: calc(80 + 11.7 + 17.31) * $px676vw + vw;
          height: calc(87.27 + 12.69 + 11.47);
          position: absolute;
          z-index: 11;
        }

      }

      .bouncy-animation-phone-description{
        font-size: 12 * $px676vw + vw;
        line-height: normal;
        margin-top: 14.18 * $px676vw + vw;
      }

    }
    // 三大技术
    .fluid-engine-card-container{
      height: 1016 * $px676vw + vw;
      padding: 36 * $px676vw + vw 0 40 * $px676vw + vw 0;
      gap: 20 * $px676vw + vw;

      .card{
        height: 300 * $px676vw + vw;
        width: 596 * $px676vw + vw;
        border-radius: 16 * $px676vw + vw;

        .fluid-engine-text-title{
          font-size: 12 * $px676vw + vw;
          line-height: normal;
        }
  
        .fluid-engine-text-sub-title{
          font-size: 20 * $px676vw + vw;
          line-height: normal;
          margin-top: 6 * $px676vw + vw;
        }
  
        .fluid-engine-text-description{
          font-size: 12 * $px676vw + vw;
          line-height: 16 * $px676vw + vw;
          color: rgba(255, 255, 255, 0.6);
          margin-top: 12 * $px676vw + vw;
          max-width: 220 * $px676vw + vw; 
        }
      }

      // 帧形变
      .fluid-engine-frame-deformation{
        .fluid-engine-frame-deformation-content{
          top: 99 * $px676vw + vw;
          left: 50 * $px676vw + vw;
          // width: 208 * $px676vw + vw;
        }
        .fluid-engine-phone-container{
          width: 120.66 * $px676vw + vw;
          height: 251 * $px676vw + vw;
          bottom: 24 * $px676vw + vw;
          left: 376 * $px676vw + vw;

          .fluid-engine-phone-wallpaper{
            width: 112.09 * $px676vw + vw;
            height: 243.36 * $px676vw + vw;
            bottom: 3.78 * $px676vw + vw;
            left: 3.78 * $px676vw + vw;
            border-radius: 11.06 * $px676vw + vw;
          }

          .fluid-engine-phone-finger{
            width: 105 * $px676vw + vw;
            height: 60 * $px676vw + vw;
            top: 167 * $px676vw + vw;
            left: 97 * $px676vw + vw;
            position: relative;
            z-index: 12;
          }
        }
      }
    
      // 帧模糊
      .fluid-engine-frame-blur{
        .fluid-engine-frame-blur-content{
          top: 99 * $px676vw + vw;
          left: 364 * $px676vw + vw;
        }
        .fluid-engine-phone-container{
          width: 220 * $px676vw + vw;
          height: 457.63 * $px676vw + vw;
          bottom: auto;
          top: -241 * $px676vw + vw;
          left: 54 * $px676vw + vw;

          .fluid-engine-phone-wallpaper{
            width: 204.37 * $px676vw + vw;
            height: 443.7 * $px676vw + vw;
            bottom: 6.88 * $px676vw + vw;
            left: 7.06 * $px676vw + vw;
            border-radius: 20.17 * $px676vw + vw;
          }
        }
      }
    
      // 一镜到底
      .fluid-engine-one-shot{
        .fluid-engine-one-shot-content{
          top: 83 * $px676vw + vw;
          left: 50 * $px676vw + vw;
        }
        .fluid-engine-phone-container{
          width: 270.42 * $px676vw + vw;
          height: 130 * $px676vw + vw;
          bottom: 85.95 * $px676vw + vw;
          right: 41.81 * $px676vw + vw;

          .fluid-engine-phone-wallpaper{
            width: 262.18 * $px676vw + vw;
            height: 120.76 * $px676vw + vw;
            bottom: 4.07 * $px676vw + vw;
            left: 4.17 * $px676vw + vw;
            border-radius: 11.92 * $px676vw + vw;
          }
        }
      }
    }
  }
}

.isMobile {
  
  .fluid-engine{
    // 蓝河流畅引擎
    .fluid-engine-home{
      height: 400 * $px360vw + vw;

      .fluid-engine-home-container{
        top: 99 * $px360vw + vw;

        .fluid-engine-home-title{
          font-size: 25 * $px360vw + vw;
          line-height: normal;
        }

        .fluid-engine-home-sub-title{
          margin-top: 12 * $px360vw + vw;
          font-size: 42 * $px360vw + vw;
          line-height: normal;
        }

      }

      .fluid-engine-home-text-container{
        top: 286 * $px360vw + vw;
        font-size: 12 * $px360vw + vw;
        line-height: 16 * $px360vw + vw;
        opacity: 1;
      }
    }
    // 双渲染架构
    .fluid-engine-slide-container{
      position: relative;

      .fluid-engine-slide-background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
        z-index: 0;
      }

      .fluid-engine-slide{
        height: 480 * $px360vw + vw;
        position: relative;
        display: flex;
        align-items: center;
        flex-direction: column;
        background: linear-gradient(0deg, #000000, #000000), radial-gradient(57% 57% at 50% 0%, #0040AA 0%, #000000 100%);
        z-index: 1;
        &:first-child{
          background: linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 1) 70%, rgba(0, 0, 0, 0) 100%);
          height: 400 * $px360vw + vw;
        }
        .fluid-engine-text-container{
          top: 36 * $px360vw + vw;
          position: absolute;
          text-align: center;
          letter-spacing: normal;
          display: flex;
          flex-direction: column;
          align-items: center;
          z-index: 1;

          .fluid-engine-title{
            font-size: 12 * $px360vw + vw;
            line-height: normal;
            color: #2785FF;
          }
          .fluid-engine-sub-title{
            font-size: 25 * $px360vw + vw;
            line-height: normal;
            color: #FFFFFF;
            margin-top: 6 * $px360vw + vw;
            white-space: nowrap;
          }
          .fluid-engine-description-container{
            font-size: 12 * $px360vw + vw;
            line-height: 16 * $px360vw + vw;
            color: rgba(255, 255, 255, 0.8);
            margin-top: 12 * $px360vw + vw;
          }
          .fluid-engine-swiper-data{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            width: auto;
            gap: 26 * $px360vw + vw;
            margin-top: 24 * $px360vw + vw;
            text-align: start;
  
            .fluid-engine-swiper-data-item{
              letter-spacing: normal;
              color: #FFFFFF;
              .fluid-engine-swiper-data-item-unit{
                font-size: 7.68 * $px360vw + vw;
                line-height: 9.22 * $px360vw + vw;
              }
              .fluid-engine-swiper-data-item-number{
                font-size: 20 * $px360vw + vw;
                line-height: 24 * $px360vw + vw;
              }
            }
          }
        }
        .fluid-engine-video-container{
          height: 250.95 * $px360vw + vw;
          width: 340 * $px360vw + vw;
          position: relative;
          &.nth-0{
            top: 141.38 * $px360vw + vw;
          }
          &.nth-1{
            top: 178 * $px360vw + vw;
          }
          &.nth-2{
            top: 211 * $px360vw + vw;
          }
          .fluid-engine-swiper-video{
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    // 看起来就流畅
    .fluid-engine-gradient-text-container{
      background: #000000;
      height: 180 * $px360vw + vw;
      .fluid-engine-gradient-text{
        top: 68 * $px360vw + vw;
        position: absolute;
        font-size: 42 * $px360vw + vw;
        line-height: normal;
        letter-spacing: normal;
        background: linear-gradient(90deg, #DBEFFF 0%, #2785FF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
    }
    // 弹性动效
    .fluid-engine-bouncy-animation{
      height: 460 * $px360vw + vw;
      display: flex;
      align-items: center;
      flex-direction: column;

      .fluid-engine-bouncy-animation-text-container{
        padding-top: 36 * $px360vw + vw;
        width: 286 * $px360vw + vw;
        .fluid-engine-bouncy-animation-title{
          font-size: 12 * $px360vw + vw;
          line-height: normal;
        }

        .fluid-engine-bouncy-animation-sub-title{
          font-size: 25 * $px360vw + vw;
          line-height: normal;
          margin-top: 6 * $px360vw + vw;
        }

        .fluid-engine-bouncy-animation-description{
          width: 264 * $px360vw + vw;
          font-size: 12 * $px360vw + vw;
          line-height: 16 * $px360vw + vw;
          margin-top: 12 * $px360vw + vw;
        }
      }

      .fluid-engine-bouncy-animation-video-container{
        margin-top: 41.84 * $px360vw + vw;

        .fluid-engine-bouncy-animation-video-left,
        .fluid-engine-bouncy-animation-video-right{
          width: 110 * $px360vw + vw;
          white-space: nowrap;
        }

        .fluid-engine-bouncy-animation-video-left{
          margin-right: 36 * $px360vw + vw;
        }

        .bouncy-animation-phone-container{
          height: 228.82 * $px360vw + vw;
        }

        .bouncy-animation-phone-model{
          width: 110 * $px360vw + vw;
          height: 228.82 * $px360vw + vw;
        }

        .bouncy-animation-phone-wallpaper{
          width: 102.18 * $px360vw + vw;
          top: 3.53 * $px360vw + vw;
          left: 3.53 * $px360vw + vw;
          border-radius: 10.08 * $px360vw + vw;
        }

        .bouncy-animation-phone-finger{
          top: calc(126.16 - 8.72) * $px360vw + vw;
          left: calc(45 - 8.04) * $px360vw + vw;
          width: calc(55 + 8.04 + 11.9) * $px360vw + vw;
          height: calc(60 + 8.72 + 7.88) * $px360vw + vw;
          position: absolute;
          z-index: 11;
        }

      }

      .bouncy-animation-phone-description{
        font-size: 12 * $px360vw + vw;
        line-height: normal;
        margin-top: 14.34 * $px360vw + vw;
      }

    }
    // 三大技术
    .fluid-engine-card-container{
      height: 1192 * $px360vw + vw;
      padding: 36 * $px360vw + vw 0;
      gap: 20 * $px360vw + vw;

      .card{
        height: 360 * $px360vw + vw;
        width: 320 * $px360vw + vw;
        border-radius: 10 * $px360vw + vw;
        display: flex;
        flex-direction: column;
        align-items: center;

        .fluid-engine-text-title{
          font-size: 12 * $px360vw + vw;
          line-height: normal;
        }
  
        .fluid-engine-text-sub-title{
          font-size: 25 * $px360vw + vw;
          line-height: normal;
          margin-top: 6 * $px360vw + vw;
        }
  
        .fluid-engine-text-description{
          font-size: 12 * $px360vw + vw;
          line-height: 16 * $px360vw + vw;
          color: rgba(255, 255, 255, 0.8);
          margin-top: 12 * $px360vw + vw;
          max-width: 276 * $px360vw + vw; 
        }
      }

      // 帧形变
      .fluid-engine-frame-deformation{
        .fluid-engine-frame-deformation-content{
          position: relative;
          width: 276 * $px360vw + vw;
          margin-top: 28 * $px360vw + vw;
          top: auto;
          left: auto;
        }
        .fluid-engine-phone-container{
          width: 88.84 * $px360vw + vw;
          height: 184.8 * $px360vw + vw;
          bottom: auto;
          right: auto;
          position: relative;
          margin-top: 15.6 * $px360vw + vw;

          .fluid-engine-phone-wallpaper{
            width: 82.53 * $px360vw + vw;
            height: 179.17 * $px360vw + vw;
            bottom: 2.78 * $px360vw + vw;
            left: 2.85 * $px360vw + vw;
            border-radius: 8.14 * $px360vw + vw;
          }

          .fluid-engine-phone-finger{
            width: 105 * $px360vw + vw;
            height: 60 * $px360vw + vw;
            top: 114.4 * $px360vw + vw;
            left: 67.04 * $px360vw + vw;
            position: relative;
            z-index: 12;
          }
        }
      }
    
      // 帧模糊
      .fluid-engine-frame-blur{
        .fluid-engine-frame-blur-content{
          top: 214 * $px360vw + vw;
          right: auto;
          position: relative;
        }
        .fluid-engine-phone-container{
          width: 181.72 * $px360vw + vw;
          height: 378 * $px360vw + vw;
          bottom: auto;
          top: -193 * $px360vw + vw;
          left: auto;
          position: relative;

          .fluid-engine-phone-wallpaper{
            width: 168.81 * $px360vw + vw;
            height: 366.49 * $px360vw + vw;
            bottom: 5.69 * $px360vw + vw;
            left: 5.83 * $px360vw + vw;
            border-radius: 16.66 * $px360vw + vw;
          }
        }
      }
    
      // 一镜到底
      .fluid-engine-one-shot{
        .fluid-engine-one-shot-content{
          top: auto;
          left: auto;
          margin-top: 28 * $px360vw + vw;
          position: relative;
        }
        .fluid-engine-phone-container{
          width: 268.34 * $px360vw + vw;
          height: 129 * $px360vw + vw;
          bottom: auto;
          right: auto;
          position: relative;
          margin-top: 35 * $px360vw + vw;

          .fluid-engine-phone-wallpaper{
            height: 119.83 * $px360vw + vw;
            width: 260.17 * $px360vw + vw;
            bottom: 4.04 * $px360vw + vw;
            left: 4.14 * $px360vw + vw;
            border-radius: 11.83 * $px360vw + vw;
          }
        }
      }
    }
  }
}
</style>